export default "mutation uploadAttachments($files:[UploadFile!]!){attachments:uploadReclamationAttachments(files:$files)}"